<template>
    <v-card elevation="0">
        <configs-popup-edit-info ref="configs-popup-edit-info"></configs-popup-edit-info>
        <c-edit-value-dialog ref="c-edit-value-dialog"></c-edit-value-dialog>
        <v-card elevation="0">
            <v-card-actions class="ma-0 pa-2">
                <v-btn color="green" class="white--text" small @click="onCreate">
                    <v-icon left small>mdi-plus</v-icon>
                    Create Shared Config
                </v-btn>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-2">
                <v-card width="100%" class="ma-0 pa-0 scroll" elevation="0">
                    <c-shared-configs-table
                        v-on:show-edit-info-popup="showEditInfoPopup"
                        v-on:show-edit-group-popup="showEditGroupPopup"
                    ></c-shared-configs-table>
                </v-card>
            </v-card-actions>
        </v-card>
    </v-card>
</template>

<script>
import CSharedConfigsTable from "@/modules/mconfigs/views/shared/c-shared-configs-table";
import ConfigsPopupEditInfo from "@/modules/mconfigs/views/popups/configs-popup-edit-info";
import CEditValueDialog from "@/modules/mconfigs/views/list/popups/c-edit-value-dialog";
import {ConfigModel} from "@/modules/mconfigs/models/ConfigModel";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";

export default {
    name: "c-shared-configs",
    components: {CSharedConfigsTable, ConfigsPopupEditInfo, CEditValueDialog},
    methods: {
        onCreate() {
            this.$refs['c-edit-value-dialog'].show("", "Shared Config Name", "CREATE").then((name) => {
                if (!name || !name.trim()) {
                    this.$notify({title: 'Name cannot be empty', type: "error"});
                    return;
                }
                let config = new ConfigModel(name.trim(), 0);
                ConfigStoreUtils.pushSharedConfig(config, {_init: true})
                    .then(() => {
                        this.$notify({title: 'Shared config created!', type: "success"});
                    }).catch((error) => {
                        this.$notify({title: 'Create failed!', text: error, type: "error"});
                    });
            }).catch(() => {});
        },
        showEditInfoPopup(config) {
            this.$refs['configs-popup-edit-info'].show(config, (config, newInfo) => {
                let copy = config.clone();
                copy.info = newInfo;
                ConfigStoreUtils.updateSharedConfigMeta(copy)
                    .then(() => {
                        this.$notify({title: 'Info successfully changed!', type: "success"});
                    }).catch((error) => {
                        this.$notify({title: 'Info change failed!', text: error, type: "error"});
                    });
            });
        },
        showEditGroupPopup(config) {
            this.$refs['c-edit-value-dialog'].show(config.group, "Shared Config Name").then((result) => {
                if (!result || !result.trim()) {
                    this.$notify({title: 'Name cannot be empty', type: "error"});
                    return;
                }
                let copy = config.clone();
                copy.group = result.trim();
                ConfigStoreUtils.updateSharedConfigMeta(copy)
                    .then(() => {
                        this.$notify({title: 'Name successfully changed!', type: "success"});
                    }).catch((error) => {
                        this.$notify({title: 'Name change failed!', text: error, type: "error"});
                    });
            }).catch(() => {});
        },
    }
}
</script>
